import { toast } from "react-toastify";

export const ParseJson = (data: any) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
};

export const catchError = (error: any, showToaster: boolean) => {
  const status = error.response ? error.response.status : null;
  if (showToaster && status === 500) {
    // toast.error("Something went wrong");
    console.error("Something went wrong");
  }
  if (showToaster && status === 403) {
    toast.error("You don't have access to it");
  }
  if (showToaster && status === 400) {
    toast.error("Invalid request");
  }
};

export const textReadableFormat = (key: string) => {
  if (key) {
    return (
      key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1")
    );
  } else {
    return "";
  }
};
